var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartesBancaires(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "120px",
    viewBox: "0 0 200 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "large/cb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 200,
    height: 120,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large",
    transform: "translate(-32.000000, -4306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "large/cb",
    transform: "translate(32.000000, 4306.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Background",
    fill: "#2F579A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.174,42.751 C179.174,34.063 172.137,27.017 163.451,27.003 L163.451,27 L106.146,27 L106.146,58.517 L163.451,58.517 L163.451,58.5 C172.137,58.485 179.174,51.439 179.174,42.751 L179.174,42.751 Z M179.174,76.177 C179.174,67.489 172.137,60.444 163.451,60.429 L163.451,60.427 L106.146,60.427 L106.146,91.945 L163.451,91.945 L163.451,91.925 C172.137,91.911 179.174,84.867 179.174,76.177 Z M62.967,60.427 L62.967,58.517 L105.043,58.517 L105.043,55.861 C105.043,40.037 92.217,27.21 76.393,27.21 L49.653,27.21 C33.829,27.21 21,40.037 21,55.861 L21,63.502 C21,79.325 33.829,92.153 49.653,92.153 L76.393,92.153 C92.217,92.153 105.043,79.325 105.043,63.502 L105.043,60.427 L62.967,60.427 L62.967,60.427 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartesBancaires);
export default __webpack_public_path__ + "static/media/cartes_bancaires.bb6e7a1401ca879e65232be43219b791.svg";
export { ForwardRef as ReactComponent };